<template>
  <div id="educationTab">
    <v-row>
      <v-col cols="12" class="text-center text-md-left"><h1>Education</h1></v-col>
      <v-col cols="12">
        <v-card class="tab-item-card" :loading="dataLoading">
          <v-card-title> Add Education History </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12"
                ><InfoBox title="Add your Education History Here, including your previous qualifications and any current courses"
              /></v-col>
              <v-col cols="12">
                <v-btn class="primary_btn w-100" prepend-icon="mdi-plus" @click="showAddEducation = true">Add Education</v-btn>
              </v-col>
            </v-row>
            <EducationList :isHiringmanager="isHiringmanager" @remove="remove" @edit="edit" :educationList="items" :addLoading="addLoading" />
          </v-card-text>

          <v-dialog persistent v-model="showAddEducation" @keydown.esc="showAddEducation = false" max-width="1000px">
            <EducationRegister
              :isHiringmanager="isHiringmanager"
              :editingItem="editingItem"
              @saved="saveEducation"
              @scrollToElement="scrollToElement"
              @cancelEditing="cancelEditing"
              :addLoading="addLoading"
              :gettingEducation="isGettingEducation"
              :isAfterSignUp="isAfterSignUp"
            />
          </v-dialog>
          <v-dialog persistent v-model="showRemoveConfirm" @keydown.esc="showRemoveConfirm = false" max-width="400px">
            <confirm-dialog
              :loading="deleteLoading"
              @confirm="confirmDelete"
              @cancel="
                showRemoveConfirm = false;
                deleteLoading = false;
              "
              :message="confirmModel"
            >
            </confirm-dialog>
          </v-dialog>
          <v-card-actions v-if="isAfterSignUp">
            <div class="wizard-action justify-end">
              <div class="d-flex ga-5">
                <v-btn
                  v-if="!isHiringmanager"
                  class="primary_btn"
                  @click="goBack"
                  :disabled="addLoading || deleteLoading"
                  :loading="addLoading || deleteLoading"
                  prepend-icon="mdi-chevron-left"
                  >Back</v-btn
                >
                <v-btn
                  v-if="!isHiringmanager"
                  class="primary_btn"
                  @click="goNext"
                  :disabled="addLoading || deleteLoading"
                  :loading="addLoading || deleteLoading"
                  append-icon="mdi-chevron-right"
                  >Next
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import EducationRegister from "./EducationRegister.vue";
import EducationList from "./EducationList.vue";
import TeamMemberService from "../../../services/TeamMemberService";
import { Teammember, Education } from "../../../models/Teammember";
import ConfirmDialog from "../../ConfirmDialog.vue";
import { ProjectMessages } from "../../../definitions/constants";
import InfoBox from "../../InfoBox.vue";
import store from "@/store";

export default defineComponent({
  props: ["selectedTeammemberModel", "gettingEducation", "formLoading", "isAfterSignUp", "educations", "isHiringmanager"],
  components: {
    EducationRegister,
    ConfirmDialog,
    EducationList,
    InfoBox,
  },
  async mounted() {
    this.$emit("getEducations", "educations");
  },
  data() {
    return {
      showAddEducation: false,
      isGettingEducation: false,
      addLoading: false,
      dataLoading: false,
      technologies: [] as string[],
      selectedItem: {} as Education,
      editingItem: null as Education | null,
      itemRemoveId: -1,
      showRemoveConfirm: false,
      teammember: {} as Teammember | null,
      selectedId: null as string | null,
      loading: false,
      deleteLoading: false,
      showDialog: false,
      items: [] as Education[] | null,
      confirmModel: {
        title: ProjectMessages.removeEducation,
        text: ProjectMessages.confirmation,
      },
    };
  },
  methods: {
    goBack() {
      this.$emit("goBack", 2);
    },
    goNext() {
      this.$emit("goNext", 3);
    },
    cancelEditing(): void {
      this.editingItem = null;
      this.showAddEducation = false;
    },
    notValid() {
      this.$emit("notValid");
    },
    remove(item: Education): void {
      this.selectedItem = item;
      this.showRemoveConfirm = true;
    },
    async confirmDelete() {
      this.deleteLoading = true;
      if (this.selectedItem) {
        var result = await TeamMemberService.deleteEducation(
          this.selectedItem.Id,
          this.selectedTeammemberModel ? this.selectedTeammemberModel.id : ""
        );
        if (result) {
          this.editingItem = null;
          this.items = result;
          store.dispatch("showSuccessMessage", ProjectMessages.succesfullyDeleteEducation);
        } else {
          store.dispatch("showErrorMessage", ProjectMessages.errorDeleteEducation);
        }
      }
      this.showRemoveConfirm = false;
      this.deleteLoading = false;
    },
    edit(item: any): void {
      this.editingItem = item;
      this.showAddEducation = true;
    },
    scrollToElement(el: any) {
      this.$emit("scrollToElement", el);
    },
    async saveEducation(event: { model: Education; callbackMethod: any }): Promise<void> {
      if (event.model) {
        this.addLoading = true;
        try {
          var result = await TeamMemberService.setEducation(event.model, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
          if (result && result.length > 0) {
            this.editingItem = null;
            this.items = result;
            if (event.model.Id) {
              store.dispatch("showSuccessMessage", ProjectMessages.succesfullyEditEducation);
            } else {
              store.dispatch("showSuccessMessage", ProjectMessages.succesfullyAddEducation);
            }

            event.callbackMethod();
            this.showAddEducation = false;
          } else {
            store.dispatch("showErrorMessage", ProjectMessages.errorAddEducation);
          }
          this.addLoading = false;
        } catch {
          store.dispatch("showErrorMessage", ProjectMessages.errorAddEducation);
        } finally {
          this.addLoading = false;
        }
      }
    },
  },
  watch: {
    formLoading(newVal) {
      this.dataLoading = newVal;
    },
    educations(newVal) {
      this.items = newVal;
    },
    gettingEducation(newVal) {
      this.isGettingEducation = newVal;
    },
  },
});
</script>
